"use strict";

// uses jQuery
(() => {
  /**
   * @namespace DeliverySetupLink
   * @property {number}  deliveryId           DeliverySetupDelivery.delivery_setup_delivery_id
   * @property {number}  priceAmount          DeliverySetupLink.price_amount
   * @property {string}  priceFormated        E.g.: "123.50 Kč"
   * @property {string}  priceFormatedAsFrom  E.g.: "Od 123.50 Kč"
   */

  const SELECTOR_DELIVERY_PAYMENT_FORM = '#kvikymart-scdpa-delivery-payment-form';
  const SELECTOR_DELIVERY_ITEM = '.kvikymart-scdpa-delivery-item';
  const SELECTOR_PAYMENT_ITEM = '.kvikymart-scdpa-payment-item';
  const SELECTOR_DELIVERY_ITEM_CHECKBOX = 'input[name=deliverySetupDeliveryId]';
  const SELECTOR_PAYMENT_ITEM_CHECKBOX = 'input[name=deliverySetupPaymentId]';
  const SELECTOR_STORES_WRAPPER = '.kvikymart-scdpa-stores-selection';
  const SELECTOR_AREAS_WRAPPER = '.kvikymart-scdpa-areas-selection';
  const SELECTOR_SUB_METHODS_WRAPPER = '.kvikymart-scdpa-subMethods-selection';
  const SELECTOR_DELIVERY_EXTERNAL_INPUTS = '.kvikymart-scdpa__deliveryExternalInput';
  const SELECTOR_AREA_INPUTS = '.kvikymart-scdpa__areaInput';
  const SELECTOR_SUB_METHOD_INPUTS = '.kvikymart-scdpa__subMethodInput';
  const SELECTOR_SELECTION_WRAPPERS = `${SELECTOR_STORES_WRAPPER}, ${SELECTOR_AREAS_WRAPPER}, ${SELECTOR_SUB_METHODS_WRAPPER}`;
  const SELECTOR_SELECTION_TRIGGER_INPUTS = `${SELECTOR_STORES_WRAPPER} input:visible, ${SELECTOR_STORES_WRAPPER} select:visible, ${SELECTOR_AREAS_WRAPPER} select:visible`;
  const SELECTOR_PRICE = '.kvikymart-scdpa-price';
  const SELECTOR_SUBMIT_BUTTON_WRAPPER = '#kvikymart-scdpa-submit';
  const SELECTOR_AJAX_LOADER_WRAPPER = '#kvikymart-scdpa-ajax-loader';
  const SELECTOR_ADDRESS_FORM_WRAPPER = '#kvikymart-scdpa-address';
  const VISIBLE = 'visible';
  const SELECTED = 'selected';
  const CHECKED = 'checked';
  const DISABLED = 'disabled';
  const PAYMENT_ITEM_EXCLUDED = 'kvikymart-scdpa-payment-item--excluded';
  const LOCKED = 'locked';
  const DATA_JS_INITIALIZED = 'data-js-initialized';
  const DATA_LINKS = 'data-kvikymart-links';
  const DATA_DEFAULT_PRICE_IS_FREE = 'data-default-price-is-free';
  const DATA_DEFAULT_PRICE_FORMATED = 'data-default-price-formated';
  const DATA_IS_FREE_PAYMENT = 'data-kvikymart-is-free-payment';
  const DATA_REQUIRED_MESSAGE = 'data-required-message';

  /** @type {jQuery} */
  let $deliveryPaymentForm;

  /** @type {jQuery} */
  let $deliveryItemCheckboxes;

  /** @type {jQuery} */
  let $paymentItemCheckboxes;

  /** @type {jQuery} */
  let $deliveryExternalInputs;

  /** @type {jQuery} */
  let $subMethodInputs;

  /** @type {jQuery} */
  let $addressFormWrapper;

  /** @type {jQuery} */
  let $ajaxLoaderWrapper;

  /** @type {string} */
  let deliveryPaymentFormStateHash = '';
  const bindFormEvents = () => {
    $deliveryItemCheckboxes.off('change', deliveryItemCheckboxChangeEventHandler).on('change', deliveryItemCheckboxChangeEventHandler);
    $paymentItemCheckboxes.off('change', paymentItemCheckboxChangeEventHandler).on('change', paymentItemCheckboxChangeEventHandler);
    $deliveryExternalInputs.off('change', deliveryExternalInputChangeEventHandler).on('change', deliveryExternalInputChangeEventHandler);
    $subMethodInputs.off('change', subMethodInputChangeEventHandler).on('change', subMethodInputChangeEventHandler);
  };
  const init = () => {
    $deliveryPaymentForm = $(SELECTOR_DELIVERY_PAYMENT_FORM);
    if (!$deliveryPaymentForm.length) {
      return;
    }
    $deliveryPaymentForm.attr(DATA_JS_INITIALIZED, 'true');
    $deliveryItemCheckboxes = $(SELECTOR_DELIVERY_ITEM_CHECKBOX, $deliveryPaymentForm);
    $paymentItemCheckboxes = $(SELECTOR_PAYMENT_ITEM_CHECKBOX, $deliveryPaymentForm);
    $deliveryExternalInputs = $(SELECTOR_DELIVERY_EXTERNAL_INPUTS, $deliveryPaymentForm);
    $subMethodInputs = $(SELECTOR_SUB_METHOD_INPUTS, $deliveryPaymentForm);
    $addressFormWrapper = $(SELECTOR_ADDRESS_FORM_WRAPPER);
    $ajaxLoaderWrapper = $(SELECTOR_AJAX_LOADER_WRAPPER);
    displayPaymentItemsDefaultPrices();
    bindFormEvents();
    hideDeliveryItemSelectionWrappers();

    // spuštění js change eventu pro delivery checkbox zatržený z backendu
    $deliveryItemCheckboxes.filter(':' + CHECKED).triggerHandler('change', [{
      isPageLoad: true
    }]);
    dispatchDeliveryMethodChangeEvent();
    document.removeEventListener('km_storeInputChanged', deliveryPaymentInputsChangeHandler);
    document.addEventListener('km_storeInputChanged', deliveryPaymentInputsChangeHandler);
    initAjaxLoading();
    dispatchDeliveryPaymentLoadedEvent();
  };
  const hideDeliveryItemSelectionWrappers = () => {
    $(SELECTOR_SELECTION_WRAPPERS, $deliveryPaymentForm).hide();
  };
  const displayPaymentItemsDefaultPrices = () => {
    $paymentItemCheckboxes.each((index, element) => {
      const $paymentItemCheckbox = $(element);
      const $priceElement = $(SELECTOR_PRICE, $paymentItemCheckbox.closest(SELECTOR_PAYMENT_ITEM));
      setupPaymentItemDefaultPriceAttributes($paymentItemCheckbox);
      $priceElement.html($paymentItemCheckbox.attr(DATA_DEFAULT_PRICE_FORMATED));
    });
  };
  const setupPaymentItemDefaultPriceAttributes = $paymentItemCheckbox => {
    if ($paymentItemCheckbox.attr(DATA_DEFAULT_PRICE_IS_FREE)) {
      return;
    }

    /** @type {DeliverySetupLink} */
    let selectedLink;

    /** @type {DeliverySetupLink[]} */
    const links = $.parseJSON($paymentItemCheckbox.attr(DATA_LINKS));
    let lowestPriceAmount = Number.MAX_SAFE_INTEGER;
    const differences = {};
    if (links) {
      for (let i = 0; i < links.length; ++i) {
        const link = links[i];
        if ($deliveryItemCheckboxes.filter('[value="' + link.deliveryId + '"]').length === 0) {
          continue;
        }
        differences[link.priceAmount] = link.priceAmount;
        if (link.priceAmount < lowestPriceAmount) {
          lowestPriceAmount = link.priceAmount;
          selectedLink = link;
        }
      }
    }
    const differencesCount = Object.keys(differences).length;
    let defaultPriceFormated, defaultPriceIsFree;
    if (!selectedLink) {
      defaultPriceFormated = '';
      defaultPriceIsFree = false;
    } else if (lowestPriceAmount === 0) {
      defaultPriceFormated = differencesCount <= 1 ? '' : selectedLink.priceFormatedAsFrom;
      defaultPriceIsFree = true;
    } else {
      defaultPriceFormated = differencesCount <= 1 ? selectedLink.priceFormated : selectedLink.priceFormatedAsFrom;
      defaultPriceIsFree = false;
    }
    $paymentItemCheckbox.attr(DATA_DEFAULT_PRICE_FORMATED, defaultPriceFormated);
    $paymentItemCheckbox.attr(DATA_DEFAULT_PRICE_IS_FREE, booleanToDataAttr(defaultPriceIsFree));
  };
  const changeSelectedClassesOnPaymentItems = () => {
    $paymentItemCheckboxes.each((index, element) => {
      const $checkbox = $(element);
      const $deliveryItem = $checkbox.closest(SELECTOR_PAYMENT_ITEM);
      if ($checkbox.prop(CHECKED) === true) {
        $deliveryItem.addClass(SELECTED);
      } else {
        $deliveryItem.removeClass(SELECTED);
      }
    });
  };
  const paymentItemCheckboxChangeEventHandler = event => {
    const $checkbox = $(event.currentTarget);
    $paymentItemCheckboxes.not($checkbox).prop(CHECKED, false);
    changeSelectedClassesOnPaymentItems();
  };
  const deliveryItemCheckboxChangeEventHandler = (event, extraParams) => {
    const $deliveryItemCheckbox = $(event.currentTarget);
    $deliveryItemCheckboxes.closest(SELECTOR_DELIVERY_ITEM).removeClass(SELECTED);
    displayPaymentItemsDefaultPrices();
    hideDeliveryItemSelectionWrappers();
    const $deliveryItem = $deliveryItemCheckbox.closest(SELECTOR_DELIVERY_ITEM);
    if ($deliveryItemCheckbox.prop(CHECKED) === true) {
      const $availablePaymentItemCheckboxes = [];
      $deliveryItem.addClass(SELECTED);
      $deliveryItemCheckboxes.not($deliveryItemCheckbox).prop(CHECKED, false);
      $(SELECTOR_SELECTION_WRAPPERS, $deliveryItem).show();
      $paymentItemCheckboxes.each((index, element) => {
        const $paymentItemCheckbox = $(element);
        const $paymentItem = $paymentItemCheckbox.closest(SELECTOR_PAYMENT_ITEM);
        const $price = $(SELECTOR_PRICE, $paymentItem);

        /** @type {DeliverySetupLink|undefined} */
        let deliverySetupLink = findDeliverySetupLink($deliveryItemCheckbox, $paymentItemCheckbox);
        //$price.html('');

        if (deliverySetupLink && !$paymentItem.hasClass(PAYMENT_ITEM_EXCLUDED)) {
          $availablePaymentItemCheckboxes.push($paymentItemCheckbox);
          $paymentItemCheckbox.prop(DISABLED, false);
          $paymentItem.removeClass(DISABLED);
          if (dataAttrToBoolean($deliveryItemCheckbox.attr(DATA_IS_FREE_PAYMENT)) === true || deliverySetupLink.priceAmount === 0) {
            $price.html('');
          } else {
            $price.html(deliverySetupLink.priceFormated);
          }
        } else {
          disablePaymentItem($paymentItemCheckbox);
        }
      });
      if ($availablePaymentItemCheckboxes.length === 1) {
        $availablePaymentItemCheckboxes[0].prop(CHECKED, true);
      }
      if (!(extraParams && extraParams.isPageLoad)) {
        const $currentExternalInput = $(SELECTOR_SELECTION_TRIGGER_INPUTS, $deliveryItem).filter((index, element) => !element.value).first();
        if ($currentExternalInput.length) {
          $currentExternalInput.focus();
        }
      }
    } else {
      $paymentItemCheckboxes.each((index, element) => {
        const $paymentItemCheckbox = $(element);
        enablePaymentItem($paymentItemCheckbox);
      });
      displayPaymentItemsDefaultPrices();
    }
    changeSelectedClassesOnPaymentItems();
    dispatchDeliveryMethodChangeEvent();
  };

  /**
   * @returns {DeliverySetupLink|null}
   */
  const findDeliverySetupLink = ($deliveryItemCheckbox, $paymentItemCheckbox) => {
    /** @type {DeliverySetupLink[]} */
    const links = $.parseJSON($paymentItemCheckbox.attr(DATA_LINKS));
    if (links) {
      for (let i = 0; i < links.length; ++i) {
        if (links[i].deliveryId === parseInt($deliveryItemCheckbox.val())) {
          return links[i];
        }
      }
    }
    return null;
  };
  const selectDeliveryItemForInput = $input => {
    const $item = $input.closest(SELECTOR_DELIVERY_ITEM);
    const $checkbox = $(SELECTOR_DELIVERY_ITEM_CHECKBOX, $item);
    if (!$checkbox.prop(CHECKED)) {
      $checkbox.prop(CHECKED, true).triggerHandler('change');
    }
  };
  const deliveryExternalInputChangeEventHandler = event => {
    const $input = $(event.currentTarget);
    if ($input.is(SELECTOR_AREA_INPUTS)) {
      $(SELECTOR_SUB_METHOD_INPUTS, $input.closest(SELECTOR_DELIVERY_ITEM)).prop(CHECKED, false);
    }
    selectDeliveryItemForInput($input);
  };
  const subMethodInputChangeEventHandler = event => {
    selectDeliveryItemForInput($(event.currentTarget));
  };
  const disablePaymentItem = $paymentItemCheckbox => {
    $paymentItemCheckbox.prop(CHECKED, false).prop(DISABLED, true);
    const $paymentItem = $paymentItemCheckbox.closest(SELECTOR_PAYMENT_ITEM);
    $paymentItem.addClass(DISABLED);
    $paymentItem.removeClass(SELECTED);
  };
  const enablePaymentItem = $paymentItemCheckbox => {
    const $paymentItem = $paymentItemCheckbox.closest(SELECTOR_PAYMENT_ITEM);
    $paymentItemCheckbox.prop(DISABLED, false);
    $paymentItem.removeClass(DISABLED);
  };
  const setDeliveryPaymentItemsLock = shouldBeLocked => {
    $paymentItemCheckboxes.each((index, element) => {
      const $paymentItemCheckbox = $(element);
      const $paymentItem = $paymentItemCheckbox.closest(SELECTOR_PAYMENT_ITEM);
      if (shouldBeLocked) {
        $paymentItem.addClass(LOCKED);
      } else {
        $paymentItem.removeClass(LOCKED);
      }
    });
    $deliveryItemCheckboxes.each((index, element) => {
      const $deliveryItemCheckbox = $(element);
      const $deliveryItem = $deliveryItemCheckbox.closest(SELECTOR_DELIVERY_ITEM);
      if (shouldBeLocked) {
        $deliveryItem.addClass(LOCKED);
      } else {
        $deliveryItem.removeClass(LOCKED);
      }
    });
  };
  const initAjaxLoading = () => {
    $(SELECTOR_SUBMIT_BUTTON_WRAPPER, $deliveryPaymentForm).hide();
    ajaxLoaderHide();
    const $allDeliveryPaymentInputs = $deliveryItemCheckboxes.add($paymentItemCheckboxes).add($deliveryExternalInputs).add($subMethodInputs);
    $allDeliveryPaymentInputs.off('change', deliveryPaymentInputsChangeHandler).on('change', deliveryPaymentInputsChangeHandler);

    // setInterval(() => {
    //     deliveryPaymentInputsChangeHandler();
    // }, 1000);
  };
  const deliveryPaymentInputsChangeHandler = () => {
    const newDeliveryPaymentFormStateHash = $deliveryPaymentForm.serialize();
    if (newDeliveryPaymentFormStateHash === deliveryPaymentFormStateHash) {
      return;
    }
    deliveryPaymentFormStateHash = newDeliveryPaymentFormStateHash;
    $deliveryPaymentForm.attr('data-valid', 0);
    //$addressFormWrapper.hide();

    ajaxLoaderShow();
    setDeliveryPaymentItemsLock(true);
    dispatchDocumentEvent('KMDeliveryPaymentAddressControl.addressFormLoad');
    $.post($deliveryPaymentForm.attr('action'), $deliveryPaymentForm.serialize(), (payload, textStatus, jqXHR) => {
      kvik_ajax.processPayload(payload);
      const $addressForm = $('form', $addressFormWrapper);
      //$addressFormWrapper.show();

      if ($addressForm.length) {
        Nette.initForm($addressForm.get(0));
        $deliveryPaymentForm.attr('data-valid', 1);
        dispatchAddressFormLoadedEvent();
      } else {
        dispatchAddressFormHiddenEvent();
        $deliveryPaymentForm.attr('data-valid', 0);
      }
    }).always(() => {
      ajaxLoaderHide();
      setDeliveryPaymentItemsLock(false);
    });
  };
  const ajaxLoaderHide = () => {
    $ajaxLoaderWrapper.removeClass(VISIBLE);
    $ajaxLoaderWrapper.html('');
  };
  const ajaxLoaderShow = () => {
    $ajaxLoaderWrapper.addClass(VISIBLE);
    $ajaxLoaderWrapper.html(km_spinner.html);
  };
  const dispatchDocumentEvent = function (name) {
    let detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    try {
      if (detail !== undefined && window.CustomEvent) {
        document.dispatchEvent(new CustomEvent(name, {
          detail
        }));
        return;
      }
      document.dispatchEvent(new Event(name));
    } catch (e) {}
  };
  const dispatchAddressFormHiddenEvent = () => {
    dispatchDocumentEvent('KMDeliveryPaymentAddressControl.addressFormHidden');
  };
  const dispatchAddressFormLoadedEvent = () => {
    dispatchDocumentEvent('KMDeliveryPaymentAddressControl.addressFormLoaded');
  };
  const dispatchDeliveryPaymentLoadedEvent = () => {
    dispatchDocumentEvent('KMDeliveryPaymentAddressControl.deliveryPaymentLoaded');
  };
  const dispatchDeliveryMethodChangeEvent = () => {
    if (!$deliveryItemCheckboxes) {
      return;
    }
    const $checkbox = $deliveryItemCheckboxes.filter(':' + CHECKED);
    if ($checkbox.length) {
      const dataObject = $checkbox.data();
      delete dataObject.netteRules;
      dataObject.checked = $checkbox.prop(CHECKED) === true;
      dispatchDocumentEvent('KMDeliveryPaymentAddressControl.deliveryMethodChange', dataObject);
    }
  };
  const booleanToDataAttr = boolean => {
    return boolean ? 'true' : 'false';
  };
  const dataAttrToBoolean = attr => {
    return `${attr}`.toLowerCase() === 'true' || `${attr}` === '1';
  };
  $(document).ready(() => {
    init();
  });
  document.addEventListener('kvik_event_ajax_snippets_update', function () {
    if (document.querySelector(SELECTOR_DELIVERY_PAYMENT_FORM)) {
      init();
    }
  });
  window.KMDeliveryPaymentAddressControl = {
    init: init,
    dispatchDeliveryMethodChangeEvent: dispatchDeliveryMethodChangeEvent
  };
})();